














import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/common/Loading.vue';
import ExceptionDialog from '@/components/common/ExceptionDialog.vue';
import MaintenanceDialog from '@/components/common/MaintenanceDialog.vue';
import { ErrorHandleStore } from '@/store/ErrorHandleStore';
import { LoadingStore } from './store/LoadingStore';

@Component({
  components: {
    Loading,
    ExceptionDialog,
    MaintenanceDialog,
  },
})
export default class App extends Vue {
  /** data */
  loadingStore = LoadingStore();
  errorHandleStore = ErrorHandleStore();

  get isLoadingData() {
    return this.loadingStore.isLoadingData;
  }
}
